import { Bodytext, Button, Heading } from '@acorns/web-components'
import styled from 'styled-components'

import Separator from 'components/Separator'
import { style } from 'theme'

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 30px 0 40px;
  position: relative;
  width: 100%;
  align-items: center;

  @media screen and (max-width: ${style(theme => theme.breakpoints.sm)}px) {
    padding: 0 0 30px;
  }
`

export const CustomMobileContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: 70px;
  left: 0px;
  width: 100vw;
  height: calc(100vh - 100px);
`

export const PreviewPortfolioContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 50px;

  @media screen and (max-width: ${style(theme => theme.breakpoints.sm)}px) {
    padding: 50px 0px;
  }
`

export const Header = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  max-width: 480px;
  text-align: center;
  margin: 0 auto 0;
`

export const HeadingStyled = styled(Heading)`
  font-size: 30px;
  line-height: 38px;
  margin-bottom: 10px;
  align-items: center;
  display: flex;

  @media screen and (max-width: ${style(theme => theme.breakpoints.sm)}px) {
    display: none;
  }
`

export const StyledHeaderBodyText = styled(Bodytext)`
  font-size: 14px;
  line-height: 22px;
  max-width: 450px;
  min-height: 45px;
`

export const OpenAccountButton = styled(Button)`
  width: 220px;
  @media screen and (max-width: ${style(theme => theme.breakpoints.sm)}px) {
    margin: 0px 20px 20px;
    width: 100%;
  }
`

export const ThickSeparator = styled(Separator)`
  height: 10px;
  margin: 0px;
  width: 100%;

  @media screen and (max-width: ${style(theme => theme.breakpoints.sm)}px) {
    display: block;
    margin: 0px -30px;
    width: calc(100% + 60px);
  }
`

export const BottomContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;
  align-items: center;
`

export const Footer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;
  padding: 30px 50px 0;

  @media screen and (max-width: ${style(theme => theme.breakpoints.sm)}px) {
    background-color: ${style(theme => theme.colors.white)};
    bottom: 0;
    left: 0;
    padding: 10px 20px 20px 20px;
    position: fixed;
    width: 100%;
  }
`

export const MobileTitleBar = styled.div`
  display: flex;
  flex-direction: row-reverse;
  gap: 73px;
  margin-bottom: 10px;
`

export const MobileTitle = styled(Heading)`
  font-size: 14px;
  line-height: 22px;
  padding-top: 5px;
`

export const MobileTitleButton = styled.button`
  border: none;
  background: none;
  margin-right: 5px;
`
export const BitcoinETFSection = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
`
export const NEWSection = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
`
export const StyledNewImage = styled.img`
  margin-right: 175px;
`
export const StyledBitcoinButton = styled(Button)`
  width: 190px;
  height: 36px;
  background-color: ${style(theme => theme.colors.slate)};
  &:hover {
    background-color: ${style(theme => theme.colors.slate)};
  }
`

export const StyledBitcoinImage = styled.img`
  margin-left: -5px;
  margin-right: 7px;
`
